const ourProcessAccordion = document.querySelector('.our-process-sec__container');

if (ourProcessAccordion) {
  const ourProcessItemsArr = document.querySelectorAll('.our-process-sec__item');

  if (ourProcessItemsArr.length) {
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    const setContentHeight = (item) => {
      const contentEl = item.querySelector('.our-process-sec__item-content');
      if (!contentEl) return;

      if (item.classList.contains('is-active')) {
        contentEl.style.maxHeight = '';
        const contentHeight = contentEl.scrollHeight + 40;
        contentEl.style.maxHeight = `${contentHeight}px`;
      } else {
        contentEl.style.maxHeight = '';
      }
    };

    const openItem = (item) => {
      if (item.classList.contains('is-active')) return;

      ourProcessItemsArr.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains('is-active')) {
          closeItem(otherItem);
        }
      });

      item.classList.add('is-active');
      setContentHeight(item);

      if (item.previousElementSibling) {
        item.previousElementSibling.classList.remove('is-next-hovered');
      }
    };

    const closeItem = (item) => {
      item.classList.remove('is-active');
      setContentHeight(item);

      if (item.previousElementSibling) {
        item.previousElementSibling.classList.remove('is-next-hovered');
      }
    };

    // click | hover
    const openInteractionType = 'hover';

    ourProcessItemsArr.forEach((item) => {
      const contentEl = item.querySelector('.our-process-sec__item-content');
      const toggleEl = item.querySelector('.our-process-sec__item-toggle');
      const btnEl = item.querySelector('.our-process-sec__item-btn');

      if (item.classList.contains('is-active')) {
        setContentHeight(item);
      }

      if (openInteractionType === 'hover') {
        item.addEventListener('mouseenter', () => {
          if (!item.classList.contains('is-active')) {
            openItem(item);
          }
        });
      } else {
        item.addEventListener('click', () => {
          if (!item.classList.contains('is-active')) {
            openItem(item);
          }
        });
      }

      const closeElement = btnEl || toggleEl;
      if (closeElement) {
        closeElement.addEventListener('click', (e) => {
          if (item.classList.contains('is-active')) {
            e.stopPropagation();
            closeItem(item);
          }
        });
      }

      item.addEventListener('mouseenter', (e) => {
        if (item.previousElementSibling && (openInteractionType === 'hover' || !item.classList.contains('is-active'))) {
          item.previousElementSibling.classList.add('is-next-hovered');
        }
      });

      item.addEventListener('mouseleave', (e) => {
        if (item.previousElementSibling) {
          item.previousElementSibling.classList.remove('is-next-hovered');
        }
      });
    });

    const handleResize = debounce(() => {
      ourProcessItemsArr.forEach((item) => {
        if (item.classList.contains('is-active')) {
          setContentHeight(item);
        }
      });
    }, 300);

    window.addEventListener('resize', handleResize);
  }
}
